import {Component} from 'react';
import { standardNumberFormat } from '../../objects/CommonUse/double_functions';

class RelatedPlayerReportCard extends Component {
    constructor(props) {
        super(props);
        this.state={
            
        }
    }

    render() {
     
    return <> 
           <tr className="row-100">
                <td className="text-center mx-4">{this.props.tableInfo.index}</td>
                <td className="text-left">{this.props.tableInfo.player}</td>
                <td className="text-center">
                    {standardNumberFormat(this.props.tableInfo.preTestScore)}</td>
                <td className="text-left">{this.props.tableInfo.playerStatus}</td>
                <td className="text-center">{this.props.tableInfo.nbrGames}</td>
                <td className="text-center">{this.props.tableInfo.nbrGameMonths}</td>
                <td className="text-center">
                    {standardNumberFormat(this.props.tableInfo.postTestScore)}</td>
            </tr>
           
    </>
    }
}

export default RelatedPlayerReportCard;